import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import Helper from "../../helpers/helpers";


export function* loadDriverCutOff() {
  
  yield takeEvery(actionTypes.DRIVER_CUT_OFF_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRIVERCUTOFFLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDriverCutOff(action.data);
      if (response.data.success && response.data.data) {
        
        if(response.data.data.export)
        {
          Helper.loadSecureFile(response.data.data.file_path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.file_name;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        }

        yield put(actions.loadDriverCutOffSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDriverCutOffFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDriverCutOffFail());
    }
  });
}


export function* driverCutOffDetail() {
  
  yield takeEvery(actionTypes.DRIVER_CUT_OFF_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRIVERCUTOFFDETAIL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.driverCutOffDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.driverCutOffDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.driverCutOffDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.driverCutOffDetailFail());
    }
  });
}

export function* getReimburseReport() {
  
  yield takeEvery(actionTypes.GET_REIMBURSE_REPORT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REIMBURSEREPORT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getReimburseReport(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getReimburseReportSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getReimburseReportFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getReimburseReportFail());
    }
  });
}

export function* driverCutOffApprove() {
  
  yield takeEvery(actionTypes.DRIVER_CUT_OFF_APPROVE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("APPRDRIVERCUTOFF");
    action.data.track_no = track_no


    yield put(actions.enableLoading());
    try {
      const response = yield API.driverCutOffApprove(action.id, action.data);
      
      if (response.data.success) {
        yield put(actions.driverCutOffApproveSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.driverCutOffApproveFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.driverCutOffApproveFail());
    }
  });
}


export function* driverCutOffCount() {
  
  yield takeEvery(actionTypes.DRIVER_CUT_OFF_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRIVERCUTOFFCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.driverCutOffCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.driverCutOffCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.driverCutOffCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.driverCutOffCountFail());
    }
  });
}



export function* driverCutOffUpdateReimburse() {
  
  yield takeEvery(actionTypes.DRIVER_CUT_OFF_UPDATE_REIMBURSE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRIVERCUTOFFUPDREIMBURSE");
    action.data.track_no = track_no


    yield put(actions.enableLoading());
    try {
      const response = yield API.driverCutOffUpdateReimburse(action.id, action.trans, action.data);
      
      if (response.data.success) {
        yield put(actions.driverCutOffUpdateReimburseSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.driverCutOffUpdateReimburseFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.driverCutOffUpdateReimburseFail());
    }
  });
}

/* ===== USER WITHDRAWAL  ===== */

export function* loadWithdrawRequest() {
  
  yield takeEvery(actionTypes.WITHDRAW_REQUEST_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WITHDRAWREQUESTLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadWithdrawRequest(action.data);
      if (response.data.success && response.data.data) {
        
        if(response.data.data.export)
        {
          Helper.loadSecureFile(response.data.data.file_path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.file_name;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        }
        
        yield put(actions.loadWithdrawRequestSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadWithdrawRequestFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadWithdrawRequestFail());
    }
  });
}



export function* withdrawRequestDetail() {
  
  yield takeEvery(actionTypes.WITHDRAW_REQUEST_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WITHDRAWREQUESTDETAIL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.withdrawRequestDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.withdrawRequestDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.withdrawRequestDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.withdrawRequestDetailFail());
    }
  });
}

export function* withdrawRequestUpdateStatus() {
  
  yield takeEvery(actionTypes.WITHDRAW_REQUEST_UPDATE_STATUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WITHDRAWREQUESTUPDSTATUS");
    action.data.track_no = track_no


    yield put(actions.enableLoading());
    try {
      const response = yield API.withdrawRequestUpdateStatus(action.id,action.data);
      
      if (response.data.success) {
        yield put(actions.withdrawRequestUpdateStatusSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.withdrawRequestUpdateStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.withdrawRequestUpdateStatusFail());
    }
  });
}


export function* withdrawRequestCount() {
  
  yield takeEvery(actionTypes.WITHDRAW_REQUEST_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WITHDRAWREQEUSTCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.withdrawRequestCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.withdrawRequestCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.withdrawRequestCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.withdrawRequestCountFail());
    }
  });
}


export function* withdrawRequestGenerateWDBatchFile() {
  yield takeEvery(actionTypes.WITHDRAW_REQUEST_GENERATE_WD_BATCH_FILE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WRGENERATEBATCHFILE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.withdrawRequestGenerateWDBatchFile(action.id, action.data);
      
      if (response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        let contentType = response.headers["content-type"];
        let filename = new Date().toString();
        let strArr = contentType.split(";");
        if (strArr && strArr.length > 0) {
          let fileArr = strArr[2].split("=");
          filename = fileArr[1];
        }
        link.href = url;
        link.setAttribute("Download", `${filename}.txt`);
        document.body.appendChild(link);
        link.click();
        yield put(actions.toastSuccess("Batch File Generated Successfully"));
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link);

        yield put(actions.withdrawRequestGenerateWDBatchFileSuccess());

      } else {
        yield put(actions.toastError("Batch File Failed to generate!"));
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.withdrawRequestGenerateWDBatchFileFail());
    }
  });
}

export function* withdrawRequestSetPendingWDToProcessing() {
  yield takeEvery(actionTypes.WITHDRAW_REQUEST_UPDATE_TO_PROCESSING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WRSETPROCESSING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.withdrawRequestSetPendingWDToProcessing(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.withdrawRequestSetPendingWDToProcessingSuccess(response.data.data));
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.withdrawRequestSetPendingWDToProcessingFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.withdrawRequestSetPendingWDToProcessingFail());
    }
  });
}

export function* withdrawRequestUploadRespondBatchFile() {
  yield takeEvery(actionTypes.WITHDRAW_REQUEST_RESPOND_BATCH_FILE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WRRESPONDBATCHFILE");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.withdrawRequestUploadRespondBatchFile(action.data);
      if (response.data.success) {
        yield put(actions.withdrawRequestUploadRespondBatchFileSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.withdrawRequestUploadRespondBatchFileFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.withdrawRequestUploadRespondBatchFileFail());
    }
  });
}


export function* getBatchFile() {
  yield takeEvery(actionTypes.GET_BATCH_FILE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WDGETBATCHFILE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getBatchFile(action.data);      
      if (response.data.success && response.data.data) {        
        
          Helper.loadSecureFile(response.data.data.path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.filename;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
      } else {
        
        alert(response.data.message);
        yield put(actions.getBatchFileFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getBatchFileFail());
    }
  });
}


export function* getResponseFile() {
  yield takeEvery(actionTypes.GET_BANK_RESPONSE_FILE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETBANKRESPONSEFILE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getResponseFile(action.data);
      if (response.data.success && response.data.data) {        
        
          Helper.loadSecureFile(response.data.data.path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.filename;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
      } else {
        
        alert(response.data.message);
        yield put(actions.getResponseFileFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getResponseFileFail());
    }
  });
}


export function* loadWalletTransactionCount() {
  
  yield takeEvery(actionTypes.WALLET_TRANSACTION_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WALLETTRANSACTIONCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadWalletTransactionCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadWalletTransactionCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadWalletTransactionCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadWalletTransactionCountFail());
    }
  });
}


export function* loadWalletBalance() {
  
  yield takeEvery(actionTypes.LOAD_WALLET_BALANCE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WALLETBALLANCE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadWalletBalance(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadWalletBalanceSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadWalletBalanceFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadWalletBalanceFail());
    }
  });
}



export function* loadWalletTransaction() {
  
  yield takeEvery(actionTypes.LOAD_WALLET_TRANSACTION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WALLETTRANSACTIONLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadWalletTransaction(action.data);
      if (response.data.success && response.data.data) {        
        
        if(response.data.data.export)
        {
          Helper.loadSecureFile(response.data.data.file_path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.file_name;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        }

        yield put(actions.loadWalletTransactionSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadWalletTransactionFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadWalletTransactionFail());
    }
  });
}



export function* loadWalletAccountList() {
  
  yield takeEvery(actionTypes.LOAD_WALLET_ACCOUNT_LIST, function*(action) {

    if(!action.data) action.data = {}
    let search = (action.data.search) ? action.data.search : ""
    let status = (action.data.status) ? action.data.status : ""
    let dateFrom = (action.data.dateFrom) ? action.data.dateFrom : ""
    let dateTo = (action.data.dateTo) ? action.data.dateTo : ""
    
    let track_no = Helper.generateTrackNo(`WALLETACCLIST${status}${search}${dateFrom}${dateTo}`);
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadWalletAccountList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadWalletAccountListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadWalletAccountListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadWalletAccountListFail());
    }
  });
}
  
export function* loadWalletAccountFilter() {
  
  yield takeEvery(actionTypes.LOAD_WALLET_ACCOUNT_FILTER, function*(action) {

    if(!action.data) action.data = {}
    
    let offset = (action.data.offset) ? action.data.offset : ""
    let limit = (action.data.limit) ? action.data.limit : ""
    let search = (action.data.search) ? action.data.search : ""

    let track_no = Helper.generateTrackNo(`WALLETACCFILTER${offset}${limit}${search}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadWalletAccountList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadWalletAccountFilterSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadWalletAccountFilterFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadWalletAccountFilterFail());
    }
  });
}


export function* loadWalletAccountCount() {
  
  yield takeEvery(actionTypes.LOAD_WALLET_ACCOUNT_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WALLETACCOUNTCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadWalletAccountCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadWalletAccountCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadWalletAccountCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadWalletAccountCountFail());
    }
  });
}

export function* updateWalletVerifyStatus() {
  yield takeEvery(actionTypes.UPDATE_WALLET_VERIFY_STATUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDWALLETVERIFYSTATUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateWalletVerifyStatus(action.id, action.data);
      if (response.data.success) {
        yield put(actions.updateWalletVerifyStatusSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.updateWalletVerifyStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateWalletVerifyStatusFail());
    }
  });
}

export function* walletVerifyUploadDoc() {
  yield takeEvery(actionTypes.WALLET_VERIFY_UPLOAD_DOC, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WALLETVERIFYUPLOADDOC");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.walletVerifyUploadDoc(action.id, action.data);
      if (response.data.success) {
        yield put(actions.walletVerifyUploadDocSuccess());

      } else {
        alert(response.data.message);
        yield put(actions.walletVerifyUploadDocFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.walletVerifyUploadDocFail());
    }
  });
}

export function* updateWalletAllowCredited() {
  yield takeEvery(actionTypes.UPDATE_WALLET_ALLOW_CREDITED, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDWALLETALLOWCREDITED");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateWalletAllowCredited(action.id, action.data);
      if (response.data.success) {
        
        if(response.data.data)
        {
          yield put(actions.updateWalletAllowCreditedSuccess(response.data.data));
        }else{

          yield put(actions.updateWalletAllowCreditedSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }

      } else {
        alert(response.data.message);
        yield put(actions.updateWalletAllowCreditedFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateWalletAllowCreditedFail());
    }
  });
}


export function* updateOnlineBankingPeriod() {
  yield takeEvery(actionTypes.UPDATE_ONLINE_BANKING_PERIOD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDWALLETALLOWCREDITED");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateOnlineBankingPeriod(action.id, action.data);
      if (response.data.success) {        

        yield put(actions.updateOnlineBankingPeriodSuccess());
        yield put(actions.toastSuccess(response.data.message));        

      } else {
        alert(response.data.message);
        yield put(actions.updateOnlineBankingPeriodFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateOnlineBankingPeriodFail());
    }
  });
}


export function* loadBankList() {
  
  yield takeEvery(actionTypes.LOAD_BANK_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("BANKLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadBankList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadBankListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadBankListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadBankListFail());
    }
  });
}

export function* loadBankAccountList() {
  
  yield takeEvery(actionTypes.LOAD_BANK_ACCOUNT_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("BANKACCOUNTLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadBankAccountList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadBankAccountListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadBankAccountListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadBankAccountListFail());
    }
  });
}

export function* createBankAccount() {
  yield takeEvery(actionTypes.CREATE_BANK_ACCOUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CREATEBANKACCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.createBankAccount(action.id, action.data);
      if (response.data.success) {
        
        if(response.data.data)
        {
          yield put(actions.createBankAccountSuccess(response.data.data));
        }else{

          yield put(actions.createBankAccountSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }

      } else {
        alert(response.data.message);
        yield put(actions.createBankAccountFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.createBankAccountFail());
    }
  });
}


export function* updateBankAccount() {
  yield takeEvery(actionTypes.UPDATE_BANK_ACCOUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDATEBANKACCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateBankAccount(action.id, action.data);
      if (response.data.success) {
        
        if(response.data.data)
        {
          yield put(actions.updateBankAccountSuccess(response.data.data));
        }else{

          yield put(actions.updateBankAccountSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }

      } else {
        alert(response.data.message);
        yield put(actions.updateBankAccountFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateBankAccountFail());
    }
  });
}


export function* setBankAccountDefault() {
  yield takeEvery(actionTypes.SET_BANK_ACCOUNT_DEFAULT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETBANKACCOUNTDEFAULT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setBankAccountDefault(action.id, action.data);
      if (response.data.success) {
        
        if(response.data.data)
        {
          yield put(actions.setBankAccountDefaultSuccess(response.data.data));
        }else{

          yield put(actions.setBankAccountDefaultSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }

      } else {
        alert(response.data.message);
        yield put(actions.setBankAccountDefaultFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setBankAccountDefaultFail());
    }
  });
}



export function* deleteBankAccount() {
  yield takeEvery(actionTypes.DELETE_BANK_ACCOUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELETEBANKACCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.deleteBankAccount(action.id, action.data);
      if (response.data.success) {
        
        if(response.data.data)
        {
          yield put(actions.deleteBankAccountSuccess(response.data.data));
        }else{

          yield put(actions.deleteBankAccountSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }

      } else {
        alert(response.data.message);
        yield put(actions.deleteBankAccountFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.deleteBankAccountFail());
    }
  });
}

export function* loadDriverPendingPayment() {
  
  yield takeEvery(actionTypes.LOAD_DRIVER_PENDING_PAYMENT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRIVERPENDINGPAYMENTLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDriverPendingPayment(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadDriverPendingPaymentSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDriverPendingPaymentFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDriverPendingPaymentFail());
    }
  });
}


export function* approveDriverPayment() {
  
  yield takeEvery(actionTypes.APPROVE_DRIVER_PAYMENT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("APPRDRIVERPAYMENT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.approveDriverPayment(action.id, action.data);
      if (response.data.success) {
        yield put(actions.approveDriverPaymentSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.approveDriverPaymentFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.approveDriverPaymentFail());
    }
  });
}

export function* loadOnlineBankingOrderList() {
  
  yield takeEvery(actionTypes.LOAD_ONLINE_BANKING_ORDER_LIST, function*(action) {

    if(!action.data) action.data = {}

    let search = (action.data.search) ? action.data.search : ""
    let service_type = (action.data.service_type) ? action.data.service_type : ""
    let filter_date = (action.data.filter_date) ? action.data.filter_date : ""
    let status = (action.data.status) ? action.data.status : ""
    let exportFile = (action.data.exportFile) ? action.data.exportFile : ""

    let track_no = Helper.generateTrackNo(`ONLINEBANKINGORDERLIST${search}${service_type}${filter_date}${status}${exportFile}`);
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadOnlineBankingOrderList(action.data);
      if (response.data.success && response.data.data) {

        if(response.data.data.export)
        {
          Helper.loadSecureFile(response.data.data.file_path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.file_name;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        }

        yield put(actions.loadOnlineBankingOrderListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadOnlineBankingOrderListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadOnlineBankingOrderListFail());
    }
  });
}


export function* processOnlineBankingTrans() {
  
  yield takeEvery(actionTypes.PROCES_ONLINE_BANKING_TRANS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("PROCESONLINEBANKINGTRANS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.processOnlineBankingTrans(action.data);
      if (response.data.success) {

        if(response.data.data)
        {
          yield put(actions.processOnlineBankingTransSuccess(response.data.data));
          
        }else{
          yield put(actions.processOnlineBankingTransSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }
      } else {
        alert(response.data.message);
        yield put(actions.processOnlineBankingTransFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.processOnlineBankingTransFail());
    }
  });
}


export function* rollbackOnlineBankingTrans() {
  
  yield takeEvery(actionTypes.ROLLBACK_ONLINE_BANKING_TRANS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("ROLLBACKONLINEBANKINGTRANS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.rollbackOnlineBankingTrans(action.data);
      if (response.data.success) {
        yield put(actions.rollbackOnlineBankingTransSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.rollbackOnlineBankingTransFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.rollbackOnlineBankingTransFail());
    }
  });
}


export default function* orderSaga() {
  yield all([fork(loadDriverCutOff)]);
  yield all([fork(driverCutOffDetail)]);
  yield all([fork(getReimburseReport)]);
  yield all([fork(driverCutOffApprove)]);
  yield all([fork(driverCutOffCount)]);
  yield all([fork(driverCutOffUpdateReimburse)]);
  
  yield all([fork(loadWithdrawRequest)]);
  yield all([fork(withdrawRequestDetail)]);
  yield all([fork(withdrawRequestUpdateStatus)]);
  yield all([fork(withdrawRequestCount)]);
  yield all([fork(withdrawRequestGenerateWDBatchFile)]);
  yield all([fork(withdrawRequestSetPendingWDToProcessing)]);
  yield all([fork(withdrawRequestUploadRespondBatchFile)]);
  yield all([fork(getBatchFile)]);
  yield all([fork(getResponseFile)]);
  yield all([fork(loadWalletTransactionCount)]);
  yield all([fork(loadWalletBalance)]);
  yield all([fork(loadWalletTransaction)]);
  yield all([fork(loadWalletAccountList)]);
  yield all([fork(loadWalletAccountFilter)]);
  yield all([fork(loadWalletAccountCount)]);
  yield all([fork(updateWalletVerifyStatus)]);  
  yield all([fork(walletVerifyUploadDoc)]);  
  yield all([fork(updateWalletAllowCredited)]); 
  yield all([fork(updateOnlineBankingPeriod)]);
  yield all([fork(loadBankList)]); 
  yield all([fork(loadBankAccountList)]); 
  yield all([fork(createBankAccount)]); 
  yield all([fork(updateBankAccount)]); 
  yield all([fork(setBankAccountDefault)]); 
  yield all([fork(deleteBankAccount)]); 
  yield all([fork(loadDriverPendingPayment)]);
  yield all([fork(approveDriverPayment)]);
  yield all([fork(loadOnlineBankingOrderList)]);
  yield all([fork(processOnlineBankingTrans)]);
  yield all([fork(rollbackOnlineBankingTrans)]);
  
}
